import { RefAttributes } from 'react';
import { Button as AntdButton } from 'antd';
import { ButtonProps, ButtonType } from 'antd/lib/button';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

type ExtendType = ButtonType | 'secondary';

type BtnType = Record<string, FlattenSimpleInterpolation>;

const BUTTON_TYPES: BtnType = {
  primary: css`
    & {
      background-color: var(--v3-black-100);
      border-color: var(--v3-black-100);
      color: var(--v3-text-color-inverse);
      &:active,
      &:hover,
      &:focus {
        background-color: var(--v3-black-85);
        border-color: var(--v3-black-85);
        color: var(--v3-text-color-inverse);
      }
    }
  `,
  secondary: css`
    & {
      background-color: var(--v3-black-2);
      border-color: var(--v3-black-2);
      color: var(--v3-text-color);
      &:active,
      &:hover,
      &:focus {
        background-color: var(--v3-black-1);
        border-color: var(--v3-black-1);
        color: var(--v3-text-color);
      }
    }
  `,
  disabled: css`
    & {
      opacity: 0.3;
    }
  `
};

const StyledButton = styled(AntdButton)<
  ButtonProps & { btnheight?: number; textsize?: number; lineheight?: number }
>`
  &&& {
    ${props => props.type && `${BUTTON_TYPES[props.type]}`};
    ${props => props.disabled && `${BUTTON_TYPES.disabled}`};
    height: ${props => props.btnheight || 44}px;
    max-width: 100%;
    font-size: ${props => props.textsize || 16}px;
    line-height: ${props => props.lineheight || 24}px;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    letter-spacing: -0.02em;

    &,
    & > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export function Button(
  props: Omit<ButtonProps, 'type'> &
    RefAttributes<HTMLElement> & {
      type?: ExtendType;
      btnheight?: number;
      textsize?: number;
      lineheight?: number;
    }
) {
  return <StyledButton {...(props as ButtonProps)} />;
}
